import { create } from 'zustand'
import type { LearningSession, SessionMessage, StreamingMessage } from '../types'

interface SessionState {
  currentSession: LearningSession | null
  messages: SessionMessage[]
  streamingMessage: StreamingMessage | null
  pendingFirstMessage: string | null
  setCurrentSession: (session: LearningSession | null) => void
  setMessages: (messages: SessionMessage[]) => void
  addMessage: (msg: SessionMessage) => void
  setStreamingMessage: (msg: StreamingMessage | null) => void
  appendStreamingContent: (delta: string) => void
  finalizeStreamingMessage: () => void
  setPendingFirstMessage: (msg: string | null) => void
  resetSession: () => void
}

export const useSessionStore = create<SessionState>((set) => ({
  currentSession: null,
  messages: [],
  streamingMessage: null,
  pendingFirstMessage: null,

  setCurrentSession: (session) => set({ currentSession: session }),

  setPendingFirstMessage: (msg) => set({ pendingFirstMessage: msg }),

  setMessages: (messages) => set({ messages }),

  addMessage: (msg) =>
    set((state) => ({ messages: [...state.messages, msg] })),

  setStreamingMessage: (msg) => set({ streamingMessage: msg }),

  appendStreamingContent: (delta) =>
    set((state) => {
      if (!state.streamingMessage) return state
      return {
        streamingMessage: {
          ...state.streamingMessage,
          content: state.streamingMessage.content + delta,
        },
      }
    }),

  finalizeStreamingMessage: () =>
    set((state) => {
      if (!state.streamingMessage) return state
      const tempMsg: SessionMessage = {
        id: `streaming-${Date.now()}`,
        sessionId: state.currentSession?.id ?? '',
        role: 'assistant',
        content: state.streamingMessage.content,
        messageUuid: `streaming-${Date.now()}`,
        tokensUsed: 0,
        metadata: null,
        createdAt: new Date().toISOString(),
      }
      return {
        messages: [...state.messages, tempMsg],
        streamingMessage: null,
      }
    }),

  resetSession: () =>
    set({ currentSession: null, messages: [], streamingMessage: null, pendingFirstMessage: null }),
}))
